import {
  productIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const addItemsToPurchaseOrder = {
  name: "addItemsToPurchaseOrder" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        quantity: z.number().int().min(0),
        receivedQuantity: z.number().int().min(0).default(0),
        damagedQuantity: z.number().int().min(0).default(0),
        unitCost: z.number().min(0).default(0),
        costCurrency: z.string().default("USD"),
        totalTax: z.number().min(0).default(0),
        taxCurrency: z.string().default("USD"),
      }),
    ),
  }),
  output: z.object({ success: z.boolean() }),
};
